"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _dashboard = require("@/api/dashboard.js");
var _index = _interopRequireDefault(require("@/components/echartsNew/index"));
var _index2 = _interopRequireDefault(require("@/components/ButtonTimePicker/index"));
var _index3 = _interopRequireDefault(require("@/components/StatisticsDataCardList/index"));
var _permission = require("@/utils/permission");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'userStatistic',
  components: {
    echartsNew: _index.default,
    ButtonTimePicker: _index2.default,
    StatisticsDataCardList: _index3.default
  },
  mixins: [],
  props: {},
  data: function data() {
    return {
      startTime: '',
      endTime: '',
      newUserLoading: true,
      activeUserLoading: true,
      boughtUserLoading: true,
      newMemberLoading: true,
      userStatisticsData: [],
      style: {
        height: '320px'
      },
      // 新增用户线形图配置
      newUserOption: {
        title: {
          text: '新增用户数量',
          left: 0,
          top: 10,
          textStyle: {
            fontSize: 18,
            fontWeight: 600
          }
        },
        grid: {
          top: 80,
          left: 0,
          right: 50,
          bottom: 40,
          containLabel: true
        },
        color: ['#5B8FF9'],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'line'
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: '#E5E8EF'
            }
          },
          axisLabel: {
            color: '#666'
          },
          data: []
        },
        yAxis: {
          type: 'value',
          name: '数量',
          position: 'left',
          min: 0,
          axisLine: {
            show: false
          },
          splitLine: {
            lineStyle: {
              color: '#F0F0F0'
            }
          },
          axisLabel: {
            color: '#666',
            margin: 30
          }
        },
        series: {
          name: '新增用户数量',
          type: 'line',
          smooth: true,
          symbol: 'none',
          symbolSize: '8',
          lineStyle: {
            width: 2
          },
          data: []
        }
      },
      // 活跃用户线形图配置
      activeUserOption: {
        title: {
          text: '活跃用户数量',
          left: 0,
          top: 10,
          textStyle: {
            fontSize: 18,
            fontWeight: 600
          }
        },
        grid: {
          top: 80,
          left: 0,
          right: 50,
          bottom: 40,
          containLabel: true
        },
        color: ['#5B8FF9'],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'line'
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: '#E5E8EF'
            }
          },
          axisLabel: {
            color: '#666'
          },
          data: []
        },
        yAxis: {
          type: 'value',
          name: '数量',
          position: 'left',
          min: 0,
          axisLine: {
            show: false
          },
          splitLine: {
            lineStyle: {
              color: '#F0F0F0'
            }
          },
          axisLabel: {
            color: '#666',
            margin: 30
          }
        },
        series: {
          name: '活跃用户数量',
          type: 'line',
          smooth: true,
          symbol: 'none',
          symbolSize: '8',
          lineStyle: {
            width: 2
          },
          data: []
        }
      },
      // 成交用户柱形图配置
      boughtUserOption: {
        title: {
          text: '成交用户数量',
          left: 0,
          top: 10,
          textStyle: {
            fontSize: 18,
            fontWeight: 600
          }
        },
        grid: {
          top: 80,
          left: 0,
          right: 50,
          bottom: 40,
          containLabel: true
        },
        color: ['#5B8FF9', '#5AD8A6'],
        legend: {
          top: 10,
          left: 'center',
          icon: 'circle',
          itemWidth: 8,
          itemHeight: 8,
          data: ['老用户', '新用户']
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'line'
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: true,
          axisLine: {
            lineStyle: {
              color: '#E5E8EF'
            }
          },
          axisLabel: {
            color: '#666'
          },
          data: []
        },
        yAxis: {
          type: 'value',
          name: '数量',
          position: 'left',
          min: 0,
          axisLine: {
            show: false
          },
          splitLine: {
            lineStyle: {
              color: '#F0F0F0'
            }
          },
          axisLabel: {
            color: '#666',
            margin: 30
          }
        },
        series: [{
          name: '老用户',
          type: 'bar',
          stack: 'bought',
          barMaxWidth: 20,
          data: []
        }, {
          name: '新用户',
          type: 'bar',
          stack: 'bought',
          barMaxWidth: 20,
          data: []
        }]
      },
      // 新增商户会员线形图配置
      newMemberOption: {
        title: {
          text: '新增商户会员数量',
          left: 0,
          top: 10,
          textStyle: {
            fontSize: 18,
            fontWeight: 600
          }
        },
        grid: {
          top: 80,
          left: 0,
          right: 50,
          bottom: 40,
          containLabel: true
        },
        color: ['#5B8FF9'],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'line'
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: '#E5E8EF'
            }
          },
          axisLabel: {
            color: '#666'
          },
          data: []
        },
        yAxis: {
          type: 'value',
          name: '数量',
          position: 'left',
          min: 0,
          axisLine: {
            show: false
          },
          splitLine: {
            lineStyle: {
              color: '#F0F0F0'
            }
          },
          axisLabel: {
            color: '#666',
            margin: 30
          }
        },
        series: {
          name: '新增商户会员数量',
          type: 'line',
          smooth: true,
          symbol: 'none',
          symbolSize: '8',
          lineStyle: {
            width: 2
          },
          data: []
        }
      }
    };
  },
  computed: {
    todayDate: function todayDate() {
      var date = new Date();
      var year = date.getFullYear();
      var month = String(date.getMonth() + 1).padStart(2, '0');
      var day = String(date.getDate()).padStart(2, '0');
      return "".concat(year, "-").concat(month, "-").concat(day);
    }
  },
  mounted: function mounted() {},
  methods: {
    checkPermi: _permission.checkPermi,
    // 获取用户统计数据
    getUserStatisticsData: function getUserStatisticsData() {
      var _this = this;
      var param = {
        startTime: this.startTime,
        endTime: this.endTime
      };
      (0, _dashboard.getUserStatisticsDataApi)(param).then(function (res) {
        _this.userStatisticsData = res;
        _this.$set(_this.userStatisticsData[0], 'isCumulativeData', true);
        _this.$set(_this.userStatisticsData[1], 'isCumulativeData', true);
      }).catch(function (err) {
        _this.$message.error(err.msg || '获取用户统计数据失败');
      });
    },
    // 获取新增用户数据
    getNewUserData: function getNewUserData() {
      var _this2 = this;
      var param = {
        startTime: this.startTime,
        endTime: this.endTime
      };
      (0, _dashboard.getNewUserDataApi)(param).then(function (res) {
        var xAxis = [],
          yAxis = [];
        res.forEach(function (item) {
          xAxis.push(item.name);
          yAxis.push(item.value);
        });
        _this2.newUserOption.xAxis.data = xAxis;
        _this2.newUserOption.series.data = yAxis;
        _this2.newUserLoading = false;
      }).catch(function (err) {
        _this2.$message.error(err.msg || '获取新增用户数据失败');
      });
    },
    // 获取活跃用户数据
    getActiveUserData: function getActiveUserData() {
      var _this3 = this;
      var param = {
        startTime: this.startTime,
        endTime: this.endTime
      };
      (0, _dashboard.getActiveUserDataApi)(param).then(function (res) {
        var xAxis = [],
          yAxis = [];
        res.forEach(function (item) {
          xAxis.push(item.name);
          yAxis.push(item.value);
        });
        _this3.activeUserOption.xAxis.data = xAxis;
        _this3.activeUserOption.series.data = yAxis;
        _this3.activeUserLoading = false;
      }).catch(function (err) {
        _this3.$message.error(err.msg || '获取活跃用户数据失败');
      });
    },
    // 获取成交用户数据
    getBoughtUserData: function getBoughtUserData() {
      var _this4 = this;
      var param = {
        startTime: this.startTime,
        endTime: this.endTime
      };
      (0, _dashboard.getBoughtUserDataApi)(param).then(function (res) {
        var xAxis = [],
          newUser = [],
          oldUser = [];
        res.forEach(function (item) {
          xAxis.push(item.date);
          newUser.push(item.newUser);
          oldUser.push(item.oldUser);
        });
        _this4.boughtUserOption.xAxis.data = xAxis;
        _this4.boughtUserOption.series[0].data = oldUser;
        _this4.boughtUserOption.series[1].data = newUser;
        _this4.boughtUserLoading = false;
      }).catch(function (err) {
        _this4.$message.error(err.msg || '获取成交用户数据失败');
      });
    },
    // 获取新增商户会员数据
    getNewMemberData: function getNewMemberData() {
      var _this5 = this;
      var param = {
        startTime: this.startTime,
        endTime: this.endTime
      };
      (0, _dashboard.getNewMemberDataApi)(param).then(function (res) {
        var xAxis = [],
          yAxis = [];
        res.forEach(function (item) {
          xAxis.push(item.name);
          yAxis.push(item.value || 0);
        });
        _this5.newMemberOption.xAxis.data = xAxis;
        _this5.newMemberOption.series.data = yAxis;
        _this5.newMemberLoading = false;
      }).catch(function (err) {
        _this5.$message.error(err.msg || '获取新增商户会员数据失败');
      });
    },
    // 日期范围更改
    dateRangeChange: function dateRangeChange(timeVal) {
      this.resetLoading();
      this.startTime = timeVal[0];
      this.endTime = timeVal[1];
      if (timeVal && timeVal[0] == timeVal[1]) {
        this.newUserOption.series.symbol = 'circle';
        this.activeUserOption.series.symbol = 'circle';
        this.newMemberOption.series.symbol = 'circle';
      } else {
        this.newUserOption.series.symbol = 'none';
        this.activeUserOption.series.symbol = 'none';
        this.newMemberOption.series.symbol = 'none';
      }
      this.getUserStatisticsData();
      this.getNewUserData();
      this.getActiveUserData();
      this.getBoughtUserData();
      this.getNewMemberData();
    },
    // 重置加载状态
    resetLoading: function resetLoading() {
      this.newUserLoading = true;
      this.activeUserLoading = true;
      this.boughtUserLoading = true;
      this.newMemberLoading = true;
    }
  }
};